<template>
    <div class="FaqItem" @click="emits('toggle')">
        <div :class="['FaqQuestion', { 'is-opened': active }]">
            <span>{{ question }}</span>
            <i :class="['ToggleIconFaq', active ? 'lnr-chevron-up' : 'lnr-chevron-down']"></i>
        </div>
        <div v-html="answer" :class="[faqAnswer.FaqAnswer, { [faqAnswer['is-opened']]: active, [faqAnswer['Hidden']]: !active }]">
        </div>
    </div>
</template>
<script lang="ts" setup>
    const emits = defineEmits(['toggle']);
    const {id, question, answer, active} = defineProps({
        id: {
            type: Number,
            required: true,
        },
        question: {
            type: String,
            required: true,
        },
        answer: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            required: true,
        },
    });
</script>
<style module="faqAnswer" lang="scss">

	.FaqAnswer {
		@include TextStyle(BodyMediumRegular);
		@include MarginAreas(0);
		@include PaddingAreas(1.5, 0.5);

		&.is-opened {
			border-bottom: 2px solid $Blue-700;
		}
        &.Hidden {
            display: none;
        }
		&:not(.Hidden) {
			background-color: $Grey-100;
		}

		a {
			color: $Blue-700;
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}

		p {
			@include MarginAreas(0);
		}
		@include Breakpoint(Large, ExtraLarge) {
			@include PaddingAreas(1.5, 1);
		}
	}
</style>
<style scoped lang="scss">
.FaqItem {
	.FaqQuestion {

		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 1rem;

		font-weight: 400;
		background-color: $White;
		cursor: pointer;

		border: 2px solid transparent;
		box-sizing: border-box;
		transition: border-color 0.2s ease;
        @include PaddingAreas(1, 0.5);
		@include MarginAreas(0);

		.ToggleIconFaq {
			display: flex;
			align-items: center;

			color: $Grey-900;
			background-color: $White;
			border: 1px solid $Grey-600;
			border-radius: 0.25rem;
            @include TextStyle(UiLargeRegular);
			@include PaddingAreas(0.5);
		}

		&.is-opened {
            border-bottom: none;
			background-color: $Grey-100;

			.ToggleIconFaq {
					color: $Blue-700;
					background-color: $Blue-100;
			}

			@include PaddingAreas(1.5, 0.5, 0, 0.5);

			&:hover {
				border-bottom: none;

				.ToggleIconFaq {
					color: $Blue-700;
					background-color: $Blue-100;
					border: 1px solid $Blue-700;
				}
			}
			@include Breakpoint(Large, ExtraLarge) {
				@include PaddingAreas(1.5, 1, 0, 1);
			}
		}

		&:hover {
			border-bottom: 2px solid $Blue-700;

			.ToggleIconFaq {
				color: $Blue-700;
				border-color: $Blue-700;
				background-color: $Blue-100;
			}
		}
		@include Breakpoint(Large, ExtraLarge) {
			@include PaddingAreas(1.5, 1);
		}
	}


	.ToggleIconFaq {
		float: right;
	}
}
</style>